import config from '@/config'
import { requests } from '.'

export const PaymentService = {
  getCurrencyDetails: () =>
    requests(config.PAYMENTS_SERVICE_URL).get(`/currency`),
}
